import { render, staticRenderFns } from "./ProductPay.vue?vue&type=template&id=6a9e7552&"
import script from "./ProductPay.vue?vue&type=script&lang=js&"
export * from "./ProductPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports